import { createOptionBindings } from '@gift/website-state/slices/variablesSlice';
import { createInputBindings } from '@gift/website-state/slices/inputsSlice';
import { EngravingVariableInput } from '@gift/engraving-core/EngravingVariableInput';
import { EngravingVariableOptions } from '@gift/engraving-core/EngravingVariableOptions';

const { createInputSelector, createInputUpdater }
    = createInputBindings<EngravingVariableInput>();

export const selectAssetUrlById = createInputSelector(i => i.assetUrl);
export const updateAssetUrlByIds = createInputUpdater('assetUrl');

const { createOptionSelector } = createOptionBindings<EngravingVariableOptions>();

export const selectIsOptionalById = createOptionSelector(i => i.isOptional);
export const selectOpenByDefaultById = createOptionSelector(o => o.openByDefault);
export const selectCollectionIdById = createOptionSelector(o => o.collectionId);